import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, distinct, map, mergeMap } from 'rxjs/operators';
import {
    loadIso3166_2CountryCodes,
    loadIso3166_2CountryCodesFailure,
    loadIso3166_2CountryCodesSuccess,
} from './actions';
import { Iso3166_2Country } from './model';

@Injectable()
export class Iso3166_2CountryCodesEffects {
    loadASNList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadIso3166_2CountryCodes),
            distinct(),
            mergeMap(() =>
                this.get().pipe(
                    map((data) => loadIso3166_2CountryCodesSuccess({ data })),
                    catchError((error) => of(loadIso3166_2CountryCodesFailure({ error }))),
                ),
            ),
        ),
    );

    private get(): Observable<Iso3166_2Country[]> {
        const url = '/assets/country-codes-3166-2.json';
        return ajax
            .get<Iso3166_2Country[]>(url)
            .pipe(map(({ response }) => response.sort((a, b) => a.name.localeCompare(b.name))));
    }

    constructor(private actions$: Actions) {}
}
